// extracted by mini-css-extract-plugin
export default {"container":"Main_container__mMBvK","cardLoading":"Main_cardLoading__qK1oj","cardsError":"Main_cardsError__5vlb6"};